<script>
    export let breakPoint = '3000px'
    export let minHeight = 'calc(100% - 70px)'
    export let style = ''
</script>

<div class="mainContainer">
    <div
        style={`display: block; max-width: ${breakPoint}; min-height: ${minHeight};${style}`}
    >
        <slot />
    </div>
</div>

<style>
    div {
        height: auto;
        position: relative;
        width: 100%;
    }
    .mainContainer {
        width: 100%;
        min-height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
    }
</style>
